const INITIAL_STATE = null;

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SETATUALIZACAO':
      state = action.atualizacao;
      return state;
    default:
      return state;
  }
};